import {observable, observe} from "mobx";
import {localStore} from "../storage";

export const observableStore = (key, o) => {
    const origin = JSON.parse(JSON.stringify(o));
    const x = {
        __change: 0,
    }
    const f = {}
    const h = {}
    Object.keys(o).forEach(k => {
        const d = Object.getOwnPropertyDescriptor(o, k)
        const v = o[k];
        if (d.get || d.set) {
            h[k] = d
        } else if ('function' === typeof v) {
            f[k] = v
        } else {
            x[k] = v
        }
    })
    const d = observable(x);
    Object.keys(h).forEach(k => {
        Object.defineProperty(d, k, h[k])
    });
    Object.keys(f).forEach(k => {
        Object.defineProperty(d, k, {
            configurable: true,
            enumerable: true,
            set(v) {
                f[k] = v;
                d.__change++
            },
            get() {
                return f[k]
            }
        })
    })

    try {
        if(!/_$/.test(key)){
        const x = localStore.getItem(key);
        const v = JSON.parse(x);
        if (v) Object.keys(v).forEach(k => {
            try {
                d[k] = v[k]
            } catch (e) {
            }
        })
        }
    } catch (e) {
    }
    d.clear = () => {
        localStore.removeItem(key);
        const o = origin.___;
        Object.keys(origin).forEach(k => {
            try {
                if(o.indexOf(k)===-1) d[k] = origin[k]
            } catch (e) {
            }
        })
    };
    observe(d, (a) => {
        if (a.name === '__change') return;
        try {
            if(/_$/.test(key))return;
            localStore.setItem(key, JSON.stringify(d))
        } catch (e) {
            console.error(e)
        }
    })
    return d;
}
